module.exports = __webpack_public_path__ + "img/server-badge.ffd38994.png";